import React from 'react';

type Props = {
    size?: {
        width: number;
        height: number;
    };
};

export const CodeIcon = ({size = {width: 32, height: 40}}: Props) => {
    return (
        <svg width={size.width} height={size.height} viewBox='0 0 32 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M1.59518 10.3571L10.4929 1.57645C10.8672 1.20709 11.3718 1 11.8977 1H28C29.6569 1 31 2.34315 31 4V36C31 37.6569 29.6569 39 28 39H4C2.34315 39 1 37.6569 1 36V11.7806C1 11.2456 1.21437 10.7329 1.59518 10.3571Z'
                stroke='#338AFF'
                strokeWidth='2'
            />
            <path d='M11 2V11C11 11.5523 10.5523 12 10 12H2' stroke='#338AFF' strokeWidth='2' />
            <path
                d='M14.5236 31.9916C14.6431 32.0244 14.7653 31.9587 14.7986 31.8412L18.7097 18.5879C18.7431 18.4731 18.6736 18.35 18.5569 18.3172L17.4792 18.0082C17.3625 17.9754 17.2375 18.0438 17.2042 18.1586L13.2931 31.4119C13.2597 31.5267 13.3292 31.6498 13.4458 31.6826L14.5236 31.9916ZM12.2125 28.6803L12.9681 27.8873C13.0542 27.7971 13.0458 27.6549 12.9542 27.5729L10.007 24.9999L12.9542 22.4269C13.0486 22.3449 13.0542 22.2027 12.9681 22.1125L12.2125 21.3195C12.1292 21.232 11.9875 21.2265 11.8986 21.3086L8.07084 24.8413C7.97639 24.9288 7.97639 25.0737 8.07084 25.1612L11.8986 28.6912C11.9875 28.7733 12.1264 28.7678 12.2125 28.6803ZM20.1042 28.6912C20.0153 28.7733 19.8764 28.7678 19.7903 28.6803L19.0347 27.8873C18.9486 27.7971 18.9542 27.6549 19.0486 27.5729L21.9958 24.9999L19.0486 22.4269C18.957 22.3449 18.9486 22.2027 19.0347 22.1125L19.7903 21.3195C19.8736 21.2293 20.0153 21.2265 20.1042 21.3086L23.9292 24.8413C24.0236 24.9288 24.0236 25.0737 23.9292 25.1612L20.1042 28.6912Z'
                fill='#338AFF'
                stroke='#338AFF'
                strokeWidth='0.5'
            />
        </svg>
    );
};
